import { HeadCell } from 'shell/components/shared/table/types';
import { CadastralVM, ResidentsListVM } from 'shell/view-models/cadastral';

export const headCellsCadastralData: HeadCell<CadastralVM, keyof CadastralVM>[] = [
  {
    id: 'section',
    label: 'Sezione',
  },
  {
    id: 'sheet',
    label: 'Foglio',
  },
  {
    id: 'particle',
    label: 'Particella',
  },
  {
    id: 'subordinate',
    label: 'Subalterno',
  },
  {
    id: 'startBlockDate',
    label: 'Data inizio blocco',
  },
  {
    id: 'endBlockDate',
    label: 'Data fine blocco',
  },
  {
    id: 'residentsNumber',
    label: 'N° residenti',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];

export const headCellsResidentsList: HeadCell<ResidentsListVM, keyof ResidentsListVM>[] = [
  {
    id: 'familyCode',
    label: 'Num. Fam.',
  },
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'sex',
    label: 'Sesso',
  },
  {
    id: 'birthDate',
    label: 'Data Nasc.',
  },
  {
    id: 'parentalRelationship',
    label: 'Par',
  },
  {
    id: 'residenceStartDate',
    label: 'Data inizio',
  },
  {
    id: 'residenceEndDate',
    label: 'Data fine',
  },
];
